import TransferPageComponent from './TransferPageComponent';

export { TransferPageComponent };
